<template>
  <div>
    <a-spin :spinning="loading">
      <a-form ref="form" name="form" :model="modelRef" :label-col="{ span: 6 }" :wrapper-col="{ span: 10 }"
              @finish="onSubmit">

        <a-form-item label="域名" name="domainName" :rules="[{ required: true, message: '必填项不允许为空' }]"
          extra="例如: https://zhuhaixinghui.tonul.cn/order/cinemaCode/44026061/ticketOrder">
          <a-input v-model:value="modelRef.domainName" placeholder="请输入域名"></a-input>
        </a-form-item>

        <a-form-item label="接口" name="interfaceName" :rules="[{ required: true, message: '必填项不允许为空' }]"
          extra="默认:/ticketInfo.do, 如非必要, 不用修改">
          <a-input v-model:value="modelRef.interfaceName" placeholder="输入接口"></a-input>
        </a-form-item>

        <a-form-item label="取票码" name="ticketNum" :rules="[{ required: true, message: '必填项不允许为空' }]">
          <a-input v-model:value="modelRef.ticketNum" placeholder="输入取票码"></a-input>
        </a-form-item>

        <div style="text-align: center;margin-bottom: 20px">
          <a-button type="primary" html-type="submit">测试接口</a-button>
        </div>

        <a-card title="接口返回" v-if="jsonData && jsonData.code">
          <vue3-markdown-it :source="markdownContent" :options="{ breaks: true }"/>
        </a-card>

      </a-form>
    </a-spin>
  </div>
</template>

<script>

  import Vue3MarkdownIt from 'vue3-markdown-it';
  import { checkCollectTickets } from "@/service/modules/system";

  export default {
    components: {Vue3MarkdownIt},
    data() {
      return {
        loading: false,
        organizationList: [],
        cinemaList: [],
        cardAllList: [],
        modelRef: {
          domainName: '',
          interfaceName: '/ticketInfo.do',
        },
        jsonData: {}
      }
    },
    created() {
    },
    computed: {
      markdownContent() {
        // ${JSON.stringify(this.jsonData, null, 2)}
        // const jsonString = JSON.stringify(this.jsonData, null, 2);
        // return md.render(`\`\`\`json\n${jsonString}\n\`\`\``)
      // ## 基础信息
      //   - 测试结果: \`${this.jsonData.code == 200 ? '成功' : '失败'}\`
        if (this.jsonData && this.jsonData.code) {
          return `

            ${(JSON.stringify(this.jsonData, null, 2)).replaceAll(',',',\n')}
          `
        } else {
          return false
        }
      }
    },
    methods: {
      async onSubmit() {
        this.loading = true;
        const postData = {
          domainName: this.modelRef.domainName,
          interfaceName: this.modelRef.interfaceName,
          ticketNum: this.modelRef.ticketNum
        };
        try {
          this.jsonData = await checkCollectTickets(postData);
        } catch (e) {
          this.jsonData = e;
        }
        this.loading = false;
      },
    }
  }
</script>

<style scoped>

</style>
